import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealMiniEntity } from '../../domain/entities/MealMiniEntity'
import type { MealListedAdminDto } from '@/backend/market'

export class MealMiniModel extends MealMiniEntity {
  constructor(dataDto: MealListedAdminDto) {
    super()
    mapEntityProperties<MealMiniEntity>(this, dataDto)
  }
}
